"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reduxForm = require("redux-form");

var _Component = _interopRequireDefault(require("./Component"));

var FORM_NAME = 'transfer-create';

var validate = function validate(values) {
  var errors = {};

  if (!values['sender']) {
    errors['sender'] = 'Обязательное поле';
  }

  if (!values['recipient']) {
    errors['recipient'] = 'Обязательное поле';
  }

  if (!values['description']) {
    errors['description'] = 'Обязательное поле';
  } else if (/(\b|\D)([456]([-\s]*\d){15,18})(\b|\D)/img.test(values['description'])) {
    errors['description'] = 'Не указывайте номер карты в описании';
  }

  if (values['sender']) {
    if (values['sender']['isShowCommissionCalculation']) {
      if (!values['amount-debit']) {
        errors['amount-debit'] = 'Обязательное поле';
      } else if (!/^(\d+)(\.\d{1,2})?$/.test(values['amount-debit'])) {
        // eslint-disable-next-line
        errors['amount-debit'] = 'Неверный формат суммы';
      } else if (Number(values['amount-debit']) > Number(values['account']['available'])) {
        errors['amount-debit'] = 'Сумма превышает доступный баланс';
      } else if (Number(values['amount-debit']) <= 0) {
        errors['amount-debit'] = 'Сумма должна быть больше 0';
      }

      if (!values['amount-credit']) {
        errors['amount-credit'] = 'Обязательное поле';
      } else if (!/^(\d+)(\.\d{1,2})?$/.test(values['amount-credit'])) {
        // eslint-disable-next-line
        errors['amount-credit'] = 'Неверный формат суммы';
      } else if (Number(values['amount-credit']) <= 0) {
        errors['amount-credit'] = 'Сумма должна быть больше 0';
      }
    } else {
      if (!values['amount']) {
        errors['amount'] = 'Обязательное поле';
      } else if (!/^(\d+)(\.\d{1,2})?$/.test(values['amount'])) {
        errors['amount'] = 'Неверный формат суммы';
      } else if (values['amount'] > values['account']['available']) {
        errors['amount'] = 'Сумма превышает доступный баланс';
      }
    }
  }

  return errors;
};

var _default = (0, _reduxForm.reduxForm)({
  form: FORM_NAME,
  validate: validate
})(_Component["default"]);

exports["default"] = _default;